export default __webpack_public_path__ + "static/man-57907d845deff474c981270e35dfffd6.png";